import Vue from 'vue'
import Router from 'vue-router'
import main from '@/pages/main'
import Index from '@/pages/index/index'
import list from '@/pages/list'
import listDetail from '@/pages/list-detail'
import restaurant from '@/pages/restaurant'
import restaurantDetail from '@/pages/restaurant-detail'
import car from '@/pages/car'
import travel from '@/pages/travel'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/main',
      component: main,
      meta: {title: '耀莱在线'},
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'Index',
          meta: {title: '首页'},
          component: Index
        },
        {
          path: '/list/:type',
          name: 'list',
          meta: {title: '商品列表'},
          component: list
        },
        {
          path: '/list-detail/:id',
          name: 'listDetail',
          component: listDetail,
          meta: {title: '商品详情'}
        },
        {
          path: '/restaurant',
          component: restaurant,
          meta: {title: '餐厅列表'}
        },
        {
          path: '/restaurant-detail/:id',
          component: restaurantDetail,
          meta: {title: '餐厅详情'}
        },
        {
          path: '/car',
          component: car,
          meta: {title: '豪车'}
        },
        {
          path: '/travel',
          component: travel,
          meta: {title: '出行'}
        }
      ]
    },
    {path: '*', redirect: '/main'}
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + ' - 耀莱在线'
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js